module.exports = __webpack_public_path__ + "img/spellbreaker_kodo_small.ac25607e.png";